/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Videos_Status_PendingInputs */

const en_settings_videos_status_pending = /** @type {(inputs: Settings_Videos_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Composing the scene…`)
};

/**
* | output |
* | --- |
* | "Composing the scene…" |
*
* @param {Settings_Videos_Status_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_videos_status_pending = /** @type {((inputs?: Settings_Videos_Status_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Videos_Status_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_videos_status_pending(inputs)
});
export { settings_videos_status_pending as "settings.videos.status_pending" }